import { ACTIONS } from "./constants";
import {
  handleNumberInput,
  handleIncrement,
  handleDecrement,
} from "./reducersUtils";
import { brandValues } from "../resources/brandList";
import { salesLabX } from "../resources/brandValues/salesLabX";


export const initialState = {
  ...salesLabX,
  selectedBrand: 'SalesLabX',
  selectBorderStyleCheckbox: 'solid',
  textareaBorderStyleCheckbox: 'solid',
  inputBorderStyleCheckbox: 'solid',
  // Error Massages
  errorTextFontSize: 14,
  errorTextFontFamily: 'inherit',
  errorHeadFontFamily: 'inherit',
  errorTextFontWeight: 400,
  errorTextColor: "#8b0000",
  errorTextTopSpacing: 5,
  errorTextPaddingInline: 0,
  errorHeadFontSize: 14,
  errorHeadFontWeight: 400,
  errorHeadColor: "#fff",
  errorHeadBottomSpacing: 15,
  errorHeadPaddingInline: 5,
  errorHeadBackground: "#8b0000",
  // Toggles
  toggleMarginBottom: 20,
  toggleMarginRight: 15,
  togglePosition: "relative",
  toggleWidth: 40,
  toggleHeight: 20,
  toggleBackgroundColor: "#9b9b9b",
  toggleBorderWidth: 1,
  toggleBorderColor: "#9b9b9b",
  toggleBorderRadius: 20,
  toggleKnobWidth: 15,
  toggleKnobHeight: 15,
  toggleKnobColor: "#fff",
  toggleKnobAlignment: 1,
  toggleKnobCheckedColor: "#fff",
  toggleCheckedBackgroundColor: "#9b9b9b",
  toggleLabelFontFamily: 'inherit',

};

export const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {

    // ############################# FORM BRAND SELECT ##############################################

    case ACTIONS.FORM_BRAND_SELECT:
      const selectedBrand = action.payload;
      return {
        ...state,
        selectedBrand: action.payload,
        ...(brandValues[selectedBrand] || {})
      };

    // ################################################################################

    case ACTIONS.FIELD_TOP_SPACING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "fieldTopSpacing",
        initialState.fieldTopSpacing
      );

    case ACTIONS.FIELD_TOP_SPACING_INCREMENT:
      return handleIncrement(state, "fieldTopSpacing");

    case ACTIONS.FIELD_TOP_SPACING_DECREMENT:
      return handleDecrement(state, "fieldTopSpacing");

    // ################################################################################

    case ACTIONS.INPUT_INLINE_PADDING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "inputPaddingInline",
        initialState.inputPaddingInline
      );

    case ACTIONS.INPUT_INLINE_PADDING_INCREMENT:
      return handleIncrement(state, "inputPaddingInline");

    case ACTIONS.INPUT_INLINE_PADDING_DECREMENT:
      return handleDecrement(state, "inputPaddingInline");

    // ################################################################################

    case ACTIONS.INPUT_HEIGHT_INPUT:
      return handleNumberInput(
        state,
        payload,
        "inputHeight",
        initialState.inputHeight
      );

    case ACTIONS.INPUT_HEIGHT_INCREMENT:
      return handleIncrement(state, "inputHeight");

    case ACTIONS.INPUT_HEIGHT_DECREMENT:
      return handleDecrement(state, "inputHeight");

    // ################################################################################

    case ACTIONS.INPUT_WIDTH_INPUT:
      return handleNumberInput(
        state,
        payload,
        "inputWidth",
        initialState.inputWidth
      );

    case ACTIONS.INPUT_WIDTH_INCREMENT:
      return handleIncrement(state, "inputWidth");

    case ACTIONS.INPUT_WIDTH_DECREMENT:
      return handleDecrement(state, "inputWidth");

    // ################################################################################

    case ACTIONS.INPUT_WIDTH_UNITS:
      return {
        ...state,
        inputWidthUnits: payload ? payload : initialState.inputWidthUnits,
      };

    // ################################################################################

    case ACTIONS.INPUT_BORDER_WIDTH_INPUT:
      return handleNumberInput(
        state,
        payload,
        "inputBorderWidth",
        initialState.inputBorderWidth
      );

    case ACTIONS.INPUT_BORDER_WIDTH_INCREMENT:
      return handleIncrement(state, "inputBorderWidth");

    case ACTIONS.INPUT_BORDER_WIDTH_DECREMENT:
      return handleDecrement(state, "inputBorderWidth");

    // ################################################################################

    case ACTIONS.INPUT_BORDER_COLOR_INPUT:
      if (payload) {
        return { ...state, inputBorderColor: payload };
      } else return { ...state, inputBorderColor: "#c3c3c3" };

    // ################################################################################

    case ACTIONS.INPUT_TOGGLE_BORDER_STYLE:
      return {
        ...state,
        inputBorderStyleCheckbox: state.inputBorderStyleCheckbox === "solid" ? "none" : "solid"
      };

    // ################################################################################

    case ACTIONS.INPUT_BORDER_RADIUS_INPUT:
      return handleNumberInput(
        state,
        payload,
        "inputBorderRadius",
        initialState.inputBorderRadius
      );

    case ACTIONS.INPUT_BORDER_RADIUS_INCREMENT:
      return handleIncrement(state, "inputBorderRadius");

    case ACTIONS.INPUT_BORDER_RADIUS_DECREMENT:
      return handleDecrement(state, "inputBorderRadius");

    // ################################################################################

    case ACTIONS.INPUT_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "inputFontSize",
        initialState.inputFontSize
      );

    case ACTIONS.INPUT_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "inputFontSize");

    case ACTIONS.INPUT_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "inputFontSize");

    // ################################################################################

    case ACTIONS.INPUT_FONT_WEIGHT_INPUT:
      return {
        ...state,
        inputFontWeight: payload
          ? Number(payload)
          : initialState.inputFontWeight,
      };

    // ################################################################################

    case ACTIONS.INPUT_FONT_FAMILY_CHANGE:
      return {
        ...state,
        inputFontFamily: action.payload,
      };

    // case ACTIONS.INPUT_FONT_FAMILY_INPUT:
    //   return {
    //     ...state,
    //     inputFontFamily: payload ? payload : initialState.inputFontFamily,
    //   };

    // ################################################################################

    case ACTIONS.INPUT_COLOR_INPUT:
      return {
        ...state,
        inputColor: payload ? payload : initialState.inputColor,
      };

    // ################################################################################

    case ACTIONS.INPUT_BACKGROUND_INPUT:
      if (payload) {
        return { ...state, inputBackgroundColor: payload };
      } else
        return {
          ...state,
          inputBackgroundColor: initialState.inputBackgroundColor,
        };

    // ################################################################################

    case ACTIONS.INPUT_HOVER_COLOR_INPUT:
      if (payload) {
        return { ...state, inputHoverColor: payload };
      } else
        return {
          ...state,
          inputHoverColor: initialState.inputHoverColor,
        };

    case ACTIONS.INPUT_HOVER_BORDER_COLOR_INPUT:
      if (payload) {
        return { ...state, inputHoverBorderColor: payload };
      } else
        return {
          ...state,
          inputHoverBorderColor: initialState.inputHoverBorderColor,
        };

    case ACTIONS.INPUT_HOVER_BACKGROUND_INPUT:
      if (payload) {
        return { ...state, inputHoverBackgroundColor: payload };
      } else
        return {
          ...state,
          inputHoverBackgroundColor: initialState.inputHoverBackgroundColor,
        };

    // ################################################################################

    // ############################## SELECT FIELD ##########################################

    case ACTIONS.SELECT_TOP_SPACING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "selectTopSpacing",
        initialState.selectTopSpacing
      );

    case ACTIONS.SELECT_TOP_SPACING_INCREMENT:
      return handleIncrement(state, "selectTopSpacing");

    case ACTIONS.SELECT_TOP_SPACING_DECREMENT:
      return handleDecrement(state, "selectTopSpacing");

    // ################################################################################

    case ACTIONS.SELECT_INLINE_PADDING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "selectPaddingInline",
        initialState.selectPaddingInline
      );

    case ACTIONS.SELECT_INLINE_PADDING_INCREMENT:
      return handleIncrement(state, "selectPaddingInline");

    case ACTIONS.SELECT_INLINE_PADDING_DECREMENT:
      return handleDecrement(state, "selectPaddingInline");

    // ################################################################################

    case ACTIONS.SELECT_HEIGHT_INPUT:
      return handleNumberInput(
        state,
        payload,
        "selectHeight",
        initialState.selectHeight
      );

    case ACTIONS.SELECT_HEIGHT_INCREMENT:
      return handleIncrement(state, "selectHeight");

    case ACTIONS.SELECT_HEIGHT_DECREMENT:
      return handleDecrement(state, "selectHeight");

    // ################################################################################

    case ACTIONS.SELECT_WIDTH_INPUT:
      return handleNumberInput(
        state,
        payload,
        "selectWidth",
        initialState.selectWidth
      );

    case ACTIONS.SELECT_WIDTH_INCREMENT:
      return handleIncrement(state, "selectWidth");

    case ACTIONS.SELECT_WIDTH_DECREMENT:
      return handleDecrement(state, "selectWidth");

    // ################################################################################

    case ACTIONS.SELECT_WIDTH_UNITS:
      return {
        ...state,
        selectWidthUnits: payload ? payload : initialState.selectWidthUnits,
      };

    // ################################################################################

    case ACTIONS.SELECT_BORDER_WIDTH_INPUT:
      return handleNumberInput(
        state,
        payload,
        "selectBorderWidth",
        initialState.selectBorderWidth
      );

    case ACTIONS.SELECT_BORDER_WIDTH_INCREMENT:
      return handleIncrement(state, "selectBorderWidth");

    case ACTIONS.SELECT_BORDER_WIDTH_DECREMENT:
      return handleDecrement(state, "selectBorderWidth");

    // ################################################################################

    case ACTIONS.SELECT_BORDER_COLOR_INPUT:
      if (payload) {
        return { ...state, selectBorderColor: payload };
      } else return { ...state, selectBorderColor: "#c3c3c3" };

    // ################################################################################

    case ACTIONS.SELECT_TOGGLE_BORDER_STYLE:
      return {
        ...state,
        selectBorderStyleCheckbox: state.selectBorderStyleCheckbox === "solid" ? "none" : "solid"
      };

    // ################################################################################

    case ACTIONS.SELECT_BORDER_RADIUS_INPUT:
      return handleNumberInput(
        state,
        payload,
        "selectBorderRadius",
        initialState.selectBorderRadius
      );

    case ACTIONS.SELECT_BORDER_RADIUS_INCREMENT:
      return handleIncrement(state, "selectBorderRadius");

    case ACTIONS.SELECT_BORDER_RADIUS_DECREMENT:
      return handleDecrement(state, "selectBorderRadius");

    // ################################################################################

    case ACTIONS.SELECT_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "selectFontSize",
        initialState.selectFontSize
      );

    case ACTIONS.SELECT_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "selectFontSize");

    case ACTIONS.SELECT_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "selectFontSize");

    // ################################################################################

    case ACTIONS.SELECT_FONT_WEIGHT_INPUT:
      return {
        ...state,
        selectFontWeight: payload
          ? Number(payload)
          : initialState.selectFontWeight,
      };

    // ################################################################################

    case ACTIONS.SELECT_FONT_FAMILY_CHANGE:
      return {
        ...state,
        selectFontFamily: action.payload,
      };

    // ################################################################################

    case ACTIONS.SELECT_COLOR_INPUT:
      return {
        ...state,
        selectColor: payload ? payload : initialState.selectColor,
      };

    // ################################################################################

    case ACTIONS.SELECT_BACKGROUND_INPUT:
      if (payload) {
        return { ...state, selectBackgroundColor: payload };
      } else
        return {
          ...state,
          selectBackgroundColor: initialState.selectBackgroundColor,
        };

    // ################################################################################

    case ACTIONS.SELECT_HOVER_COLOR_INPUT:
      if (payload) {
        return { ...state, selectHoverColor: payload };
      } else
        return {
          ...state,
          selectHoverColor: initialState.selectHoverColor,
        };

    case ACTIONS.SELECT_HOVER_BORDER_COLOR_INPUT:
      if (payload) {
        return { ...state, selectHoverBorderColor: payload };
      } else
        return {
          ...state,
          selectHoverBorderColor: initialState.selectHoverBorderColor,
        };

    case ACTIONS.SELECT_HOVER_BACKGROUND_INPUT:
      if (payload) {
        return { ...state, selectHoverBackgroundColor: payload };
      } else
        return {
          ...state,
          selectHoverBackgroundColor: initialState.selectHoverBackgroundColor,
        };

    // ################################################################################

    case ACTIONS.SELECT_BACKGROUND_IMAGE_INPUT:
      return {
        ...state,
        selectBackgroundImage: payload
          ? payload
          : initialState.selectBackgroundImage,
      };

    case ACTIONS.SELECT_BACKGROUND_IMAGE_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "selectBackgroundImageSize",
        initialState.selectBackgroundImageSize
      );
    case ACTIONS.SELECT_BACKGROUND_IMAGE_SIZE_INCREMENT:
      return handleIncrement(state, "selectBackgroundImageSize");

    case ACTIONS.SELECT_BACKGROUND_IMAGE_SIZE_DECREMENT:
      return handleDecrement(state, "selectBackgroundImageSize");

    case ACTIONS.SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_INPUT:
      return handleNumberInput(
        state,
        payload,
        "selectBackgroundImagePositionRight",
        initialState.selectBackgroundImagePositionRight
      );
    case ACTIONS.SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_INCREMENT:
      return handleIncrement(state, "selectBackgroundImagePositionRight");

    case ACTIONS.SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_DECREMENT:
      return handleDecrement(state, "selectBackgroundImagePositionRight");

    case ACTIONS.SELECT_TOGGLE_BACKGROUND_IMAGE:
      return {
        ...state,
        addSelectBackgroundImage: !state.addSelectBackgroundImage,
        selectBackgroundImage: !state.addSelectBackgroundImage
          ? "https://www2.saleslabx.com/l/722833/2024-01-23/349k8k/722833/1706025422ysweJzUO/Dropdown_dark_arrow.png"
          : '',
      };


    // ############################## TEXTAERA FIELD ##########################################

    case ACTIONS.TEXTAREA_TOP_SPACING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "textAreaTopSpacing",
        initialState.selectTopSpacing
      );

    case ACTIONS.TEXTAREA_TOP_SPACING_INCREMENT:
      return handleIncrement(state, "textAreaTopSpacing");

    case ACTIONS.TEXTAREA_TOP_SPACING_DECREMENT:
      return handleDecrement(state, "textAreaTopSpacing");

    // ################################################################################

    case ACTIONS.TEXTAREA_INLINE_PADDING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "textAreaPaddingInline",
        initialState.textAreaPaddingInline
      );

    case ACTIONS.TEXTAREA_INLINE_PADDING_INCREMENT:
      return handleIncrement(state, "textAreaPaddingInline");

    case ACTIONS.TEXTAREA_INLINE_PADDING_DECREMENT:
      return handleDecrement(state, "textAreaPaddingInline");

    // ################################################################################

    case ACTIONS.TEXTAREA_HEIGHT_INPUT:
      return handleNumberInput(
        state,
        payload,
        "textAreaHeight",
        initialState.textAreaHeight
      );

    case ACTIONS.TEXTAREA_HEIGHT_INCREMENT:
      return handleIncrement(state, "textAreaHeight");

    case ACTIONS.TEXTAREA_HEIGHT_DECREMENT:
      return handleDecrement(state, "textAreaHeight");

    // ################################################################################

    case ACTIONS.TEXTAREA_WIDTH_INPUT:
      return handleNumberInput(
        state,
        payload,
        "textAreaWidth",
        initialState.textAreaWidth
      );

    case ACTIONS.TEXTAREA_WIDTH_INCREMENT:
      return handleIncrement(state, "textAreaWidth");

    case ACTIONS.TEXTAREA_WIDTH_DECREMENT:
      return handleDecrement(state, "textAreaWidth");

    // ################################################################################

    case ACTIONS.TEXTAREA_WIDTH_UNITS:
      return {
        ...state,
        textAreaWidthUnits: payload ? payload : initialState.textAreaWidthUnits,
      };

    // ################################################################################

    case ACTIONS.TEXTAREA_BORDER_WIDTH_INPUT:
      return handleNumberInput(
        state,
        payload,
        "textAreaBorderWidth",
        initialState.textAreaBorderWidth
      );

    case ACTIONS.TEXTAREA_BORDER_WIDTH_INCREMENT:
      return handleIncrement(state, "textAreaBorderWidth");

    case ACTIONS.TEXTAREA_BORDER_WIDTH_DECREMENT:
      return handleDecrement(state, "textAreaBorderWidth");

    // ################################################################################

    case ACTIONS.TEXTAREA_BORDER_COLOR_INPUT:
      if (payload) {
        return { ...state, textAreaBorderColor: payload };
      } else return { ...state, textAreaBorderColor: "#c3c3c3" };

    // ################################################################################

    case ACTIONS.TEXTAREA_TOGGLE_BORDER_STYLE:
      return {
        ...state,
        textareaBorderStyleCheckbox: state.textareaBorderStyleCheckbox === "solid" ? "none" : "solid"
      };

    // ################################################################################

    case ACTIONS.TEXTAREA_BORDER_RADIUS_INPUT:
      return handleNumberInput(
        state,
        payload,
        "textAreaBorderRadius",
        initialState.textAreaBorderRadius
      );

    case ACTIONS.TEXTAREA_BORDER_RADIUS_INCREMENT:
      return handleIncrement(state, "textAreaBorderRadius");

    case ACTIONS.TEXTAREA_BORDER_RADIUS_DECREMENT:
      return handleDecrement(state, "textAreaBorderRadius");

    // ################################################################################

    case ACTIONS.TEXTAREA_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "textAreaFontSize",
        initialState.selectFontSize
      );

    case ACTIONS.TEXTAREA_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "textAreaFontSize");

    case ACTIONS.TEXTAREA_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "textAreaFontSize");

    // ################################################################################

    case ACTIONS.TEXTAREA_FONT_WEIGHT_INPUT:
      return {
        ...state,
        textAreaFontWeight: payload
          ? Number(payload)
          : initialState.textAreaFontWeight,
      };

    // ################################################################################

    case ACTIONS.TEXTAREA_FONT_FAMILY_CHANGE:
      return {
        ...state,
        textAreaFontFamily: action.payload,
      };

    // ################################################################################

    case ACTIONS.TEXTAREA_COLOR_INPUT:
      return {
        ...state,
        textAreaColor: payload ? payload : initialState.textAreaColor,
      };

    // ################################################################################

    case ACTIONS.TEXTAREA_BACKGROUND_INPUT:
      if (payload) {
        return { ...state, textAreaBackgroundColor: payload };
      } else
        return {
          ...state,
          textAreaBackgroundColor: initialState.textAreaBackgroundColor,
        };

    // ################################################################################

    case ACTIONS.TEXTAREA_HOVER_COLOR_INPUT:
      if (payload) {
        return { ...state, textAreaHoverColor: payload };
      } else
        return {
          ...state,
          textAreaHoverColor: initialState.textAreaHoverColor,
        };

    case ACTIONS.TEXTAREA_HOVER_BORDER_COLOR_INPUT:
      if (payload) {
        return { ...state, textAreaHoverBorderColor: payload };
      } else
        return {
          ...state,
          textAreaHoverBorderColor: initialState.textAreaHoverBorderColor,
        };

    case ACTIONS.TEXTAREA_HOVER_BACKGROUND_INPUT:
      if (payload) {
        return { ...state, textAreaHoverBackgroundColor: payload };
      } else
        return {
          ...state,
          textAreaHoverBackgroundColor: initialState.textAreaHoverBackgroundColor,
        };

    // ################################## PLACEHOLER #####################################

    case ACTIONS.PLACEHOLDER_COLOR_INPUT:
      if (payload) {
        return { ...state, placeholderColor: payload };
      } else
        return {
          ...state,
          placeholderColor: initialState.placeholderColor,
        };
    case ACTIONS.PLACEHOLDER_HOVER_COLOR_INPUT:
      if (payload) {
        return { ...state, placeholderHoverColor: payload };
      } else
        return {
          ...state,
          placeholderHoverColor: initialState.placeholderHoverColor,
        };

    case ACTIONS.PLACEHOLDER_FONT_FAMILY_CHANGE:
      return {
        ...state,
        placeholderFontFamily: action.payload,
      };

    // case ACTIONS.PLACEHOLDER_FONT_FAMILY_INPUT:
    //   return {
    //     ...state,
    //     placeholderFontFamily: payload
    //       ? payload
    //       : initialState.placeholderFontFamily,
    //   };

    case ACTIONS.PLACEHOLDER_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "placeholderFontSize",
        initialState.placeholderFontSize
      );

    case ACTIONS.PLACEHOLDER_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "placeholderFontSize");

    case ACTIONS.PLACEHOLDER_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "placeholderFontSize");

    case ACTIONS.PLACEHOLDER_FONT_WEIGHT_INPUT:
      return {
        ...state,
        placeholderFontWeight: payload
          ? Number(payload)
          : initialState.placeholderFontWeight,
      };

    case ACTIONS.TOGGLE_PLACEHOLDERS:
      return { ...state, addPlaceholders: !state.addPlaceholders };

    // ################################################################################
    // FIELD LABEL - FONT SIZE

    case ACTIONS.FIELD_LABEL_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "fieldLabelFontSize",
        initialState.fieldLabelFontSize
      );

    case ACTIONS.FIELD_LABEL_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "fieldLabelFontSize");

    case ACTIONS.FIELD_LABEL_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "fieldLabelFontSize");

    // ################################################################################
    // FIELD LABEL - FONT FAMILY

    case ACTIONS.FIELD_LABEL_FONT_FAMILY_CHANGE:
      return {
        ...state,
        fieldLabelFontFamily: action.payload,
      };

    // ################################################################################
    // FIELD LABEL - FONT WEIGHT

    case ACTIONS.FIELD_LABEL_FONT_WEIGHT_INPUT:
      return {
        ...state,
        fieldLabelFontWeight: payload
          ? Number(payload)
          : initialState.fieldLabelFontWeight,
      };

    // ################################################################################
    // FIELD LABEL - BOTTOM SPACING

    case ACTIONS.FIELD_LABEL_BOTTOM_SPACING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "fieldLabelBottomSpacing",
        initialState.fieldTopSpacing
      );

    case ACTIONS.FIELD_LABEL_BOTTOM_SPACING_INCREMENT:
      return handleIncrement(state, "fieldLabelBottomSpacing");

    case ACTIONS.FIELD_LABEL_BOTTOM_SPACING_DECREMENT:
      return handleDecrement(state, "fieldLabelBottomSpacing");

    // ################################################################################
    // FIELD LABEL - PADDING

    case ACTIONS.FIELD_LABEL_PADDING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "fieldLabelPadding",
        initialState.fieldLabelPadding
      );

    case ACTIONS.FIELD_LABEL_PADDING_INCREMENT:
      return handleIncrement(state, "fieldLabelPadding");

    case ACTIONS.FIELD_LABEL_PADDING_DECREMENT:
      return handleDecrement(state, "fieldLabelPadding");

    // ################################################################################
    // FIELD LABEL - TEXT COLOR

    case ACTIONS.FIELD_LABEL_COLOR_INPUT:
      return {
        ...state,
        fieldLabelColor: payload ? payload : initialState.fieldLabelColor,
      };

    // ################################################################################
    // FIELD LABEL - ASTERISK COLOR

    case ACTIONS.FIELD_LABEL_COLOR_ASTERISK:
      return {
        ...state,
        fieldLabelColorAsterisk: payload ? payload : initialState.fieldLabelColorAsterisk,
      };

    // ################################################################################
    // FIELD LABEL - ALIGNMENT

    case ACTIONS.FIELD_LABEL_ALIGNMENT:
      return {
        ...state,
        fieldLabelAlignment: payload ? payload : initialState.fieldLabelAlignment,
      };

    // ################################################################################
    // FIELD LABEL - TOGGLE
    case ACTIONS.TOGGLE_FIELD_LABEL:
      return { ...state, removeFieldLabels: !state.removeFieldLabels };

    // ################################################################################
    // DESCRIPTION

    case ACTIONS.DESCRIPTION_TOP_SPACING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "descriptionTopSpacing",
        initialState.fieldTopSpacing
      );

    case ACTIONS.DESCRIPTION_TOP_SPACING_INCREMENT:
      return handleIncrement(state, "descriptionTopSpacing");

    case ACTIONS.DESCRIPTION_TOP_SPACING_DECREMENT:
      return handleDecrement(state, "descriptionTopSpacing");

    // ################################################################################

    case ACTIONS.DESCRIPTION_INLINE_PADDING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "descriptionPaddingInline",
        initialState.inputPaddingInline
      );

    case ACTIONS.DESCRIPTION_INLINE_PADDING_INCREMENT:
      return handleIncrement(state, "descriptionPaddingInline");

    case ACTIONS.DESCRIPTION_INLINE_PADDING_DECREMENT:
      return handleDecrement(state, "descriptionPaddingInline");

    // ################################################################################

    case ACTIONS.DESCRIPTION_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "descriptionFontSize",
        initialState.descriptionFontSize
      );

    case ACTIONS.DESCRIPTION_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "descriptionFontSize");

    case ACTIONS.DESCRIPTION_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "descriptionFontSize");

    // ################################################################################

    case ACTIONS.DESCRIPTION_FONT_WEIGHT_INPUT:
      return {
        ...state,
        descriptionFontWeight: payload
          ? Number(payload)
          : initialState.descriptionFontWeight,
      };

    // ################################################################################

    case ACTIONS.DESCRIPTION_FONT_FAMILY_CHANGE:
      return {
        ...state,
        descriptionFontFamily: action.payload,
      };

    // ################################################################################

    case ACTIONS.DESCRIPTION_COLOR_INPUT:
      return {
        ...state,
        descriptionColor: payload ? payload : initialState.descriptionColor,
      };

    // ################################################################################

    case ACTIONS.TOGGLE_DESCRIPTION:
      return { ...state, addDescription: !state.addDescription };
    case ACTIONS.TOGGLE_DESCRIPTION_CONTENT:
      return {
        ...state,
        checkedDescriptionContent: payload,
      };

    // ################################################################################
    // CHECKBOX

    case ACTIONS.TOGGLE_CHECKBOX:
      return { ...state, addCheckbox: !state.addCheckbox };
    case ACTIONS.TOGGLE_CHECKBOX_CONTENT:
      return {
        ...state,
        checkedCheckboxContent: payload,
      };
    // #############
    case ACTIONS.CHECKBOX_INPUT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "checkboxInputSize",
        initialState.checkboxInputSize
      );

    case ACTIONS.CHECKBOX_INPUT_SIZE_INCREMENT:
      return handleIncrement(state, "checkboxInputSize");

    case ACTIONS.CHECKBOX_INPUT_SIZE_DECREMENT:
      return handleDecrement(state, "checkboxInputSize");
    // #############

    case ACTIONS.CHECKBOX_BORDER_WIDTH_INPUT:
      return handleNumberInput(
        state,
        payload,
        "checkboxBorderWidth",
        initialState.checkboxBorderWidth
      );

    case ACTIONS.CHECKBOX_BORDER_WIDTH_INCREMENT:
      return handleIncrement(state, "checkboxBorderWidth");

    case ACTIONS.CHECKBOX_BORDER_WIDTH_DECREMENT:
      return handleDecrement(state, "checkboxBorderWidth");

    // #############

    case ACTIONS.CHECKBOX_BORDER_RADIUS_INPUT:
      return handleNumberInput(
        state,
        payload,
        "checkboxBorderRadius",
        initialState.checkboxBorderRadius
      );

    case ACTIONS.CHECKBOX_BORDER_RADIUS_INCREMENT:
      return handleIncrement(state, "checkboxBorderRadius");

    case ACTIONS.CHECKBOX_BORDER_RADIUS_DECREMENT:
      return handleDecrement(state, "checkboxBorderRadius");

    // #############

    case ACTIONS.CHECKBOX_UNCHECKED_BORDER_COLOR_INPUT:
      if (payload) {
        return { ...state, checkboxUncheckedBorderColor: payload };
      } else
        return {
          ...state,
          checkboxUncheckedBorderColor:
            initialState.checkboxUncheckedBorderColor,
        };

    case ACTIONS.CHECKBOX_UNCHECKED_BACKGROUND_COLOR_INPUT:
      if (payload) {
        return { ...state, checkboxUncheckedBackgroundColor: payload };
      } else
        return {
          ...state,
          checkboxUncheckedBackgroundColor:
            initialState.checkboxUncheckedBackgroundColor,
        };

    // #############
    case ACTIONS.CHECKBOX_CHECKED_BACKGROUND_COLOR_INPUT:
      if (payload) {
        return { ...state, checkboxCheckedBackgroundColor: payload };
      } else
        return {
          ...state,
          checkboxCheckedBackgroundColor:
            initialState.checkboxCheckedBackgroundColor,
        };

    case ACTIONS.CHECKBOX_CHECKED_BORDER_COLOR_INPUT:
      if (payload) {
        return { ...state, checkboxCheckedBorderColor: payload };
      } else
        return {
          ...state,
          checkboxCheckedBorderColor: initialState.checkboxCheckedBorderColor,
        };
    case ACTIONS.CHECKBOX_CHECKED_COLOR_INPUT:
      if (payload) {
        return { ...state, checkboxCheckedColor: payload };
      } else
        return {
          ...state,
          checkboxCheckedColor: initialState.checkboxCheckedColor,
        };
    case ACTIONS.CHECKBOX_ALIGNMENT:
      return {
        ...state,
        checkboxAlignment: payload ? payload : initialState.checkboxAlignment,
      };

    // ################################################################################
    // CHECKBOX LABEL - FONT SIZE

    case ACTIONS.CHECKBOX_LABEL_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "checkboxLabelFontSize",
        initialState.checkboxLabelFontSize
      );

    case ACTIONS.CHECKBOX_LABEL_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "checkboxLabelFontSize");

    case ACTIONS.CHECKBOX_LABEL_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "checkboxLabelFontSize");

    // ################################################################################
    // CHECKBOX LABEL - FONT FAMILY

    case ACTIONS.CHECKBOX_LABEL_FONT_FAMILY_CHANGE:
      return {
        ...state,
        checkboxLabelFontFamily: action.payload,
      };

    // ################################################################################
    // CHECKBOX LABEL - FONT WEIGHT

    case ACTIONS.CHECKBOX_LABEL_FONT_WEIGHT_INPUT:
      return {
        ...state,
        checkboxLabelFontWeight: payload
          ? Number(payload)
          : initialState.checkboxLabelFontWeight,
      };
    // ################################################################################
    // CHECKBOX LABEL - TEXT COLOR

    case ACTIONS.CHECKBOX_LABEL_COLOR_INPUT:
      return {
        ...state,
        checkboxLabelColor: payload ? payload : initialState.checkboxLabelColor,
      };

    // ################################################################################

    // RADIO

    case ACTIONS.TOGGLE_RADIO:
      return { ...state, addRadioButton: !state.addRadioButton };

    // #############
    case ACTIONS.RADIO_INPUT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "radioInputSize",
        initialState.radioInputSize
      );

    case ACTIONS.RADIO_INPUT_SIZE_INCREMENT:
      return handleIncrement(state, "radioInputSize");

    case ACTIONS.RADIO_INPUT_SIZE_DECREMENT:
      return handleDecrement(state, "radioInputSize");
    // #############

    case ACTIONS.RADIO_BORDER_WIDTH_INPUT:
      return handleNumberInput(
        state,
        payload,
        "radioBorderWidth",
        initialState.radioBorderWidth
      );

    case ACTIONS.RADIO_BORDER_WIDTH_INCREMENT:
      return handleIncrement(state, "radioBorderWidth");

    case ACTIONS.RADIO_BORDER_WIDTH_DECREMENT:
      return handleDecrement(state, "radioBorderWidth");

    // #############

    case ACTIONS.RADIO_BORDER_RADIUS_INPUT:
      return handleNumberInput(
        state,
        payload,
        "radioBorderRadius",
        initialState.radioBorderRadius
      );

    case ACTIONS.RADIO_BORDER_RADIUS_INCREMENT:
      return handleIncrement(state, "radioBorderRadius");

    case ACTIONS.RADIO_BORDER_RADIUS_DECREMENT:
      return handleDecrement(state, "radioBorderRadius");

    // #############

    case ACTIONS.RADIO_UNCHECKED_BORDER_COLOR_INPUT:
      if (payload) {
        return { ...state, radioUncheckedBorderColor: payload };
      } else
        return {
          ...state,
          radioUncheckedBorderColor: initialState.radioUncheckedBorderColor,
        };

    case ACTIONS.RADIO_UNCHECKED_BACKGROUND_COLOR_INPUT:
      if (payload) {
        return { ...state, radioUncheckedBackgroundColor: payload };
      } else
        return {
          ...state,
          radioUncheckedBackgroundColor:
            initialState.radioUncheckedBackgroundColor,
        };

    // #############
    case ACTIONS.RADIO_CHECKED_BACKGROUND_COLOR_INPUT:
      if (payload) {
        return { ...state, radioCheckedBackgroundColor: payload };
      } else
        return {
          ...state,
          radioCheckedBackgroundColor: initialState.radioCheckedBackgroundColor,
        };

    case ACTIONS.RADIO_CHECKED_BORDER_COLOR_INPUT:
      if (payload) {
        return { ...state, radioCheckedBorderColor: payload };
      } else
        return {
          ...state,
          radioCheckedBorderColor: initialState.radioCheckedBorderColor,
        };

    case ACTIONS.RADIO_ALIGNMENT:
      return {
        ...state,
        radioAlignment: payload ? payload : initialState.radioAlignment,
      };

    // ################################################################################
    // RADIO LABEL - FONT SIZE

    case ACTIONS.RADIO_LABEL_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "radioLabelFontSize",
        initialState.radioLabelFontSize
      );

    case ACTIONS.RADIO_LABEL_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "radioLabelFontSize");

    case ACTIONS.RADIO_LABEL_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "radioLabelFontSize");

    // ################################################################################
    // RADIO  LABEL - FONT FAMILY

    case ACTIONS.RADIO_LABEL_FONT_FAMILY_CHANGE:
      return {
        ...state,
        radioLabelFontFamily: action.payload,
      };

    // ################################################################################
    // RADIO LABEL - FONT WEIGHT

    case ACTIONS.RADIO_LABEL_FONT_WEIGHT_INPUT:
      return {
        ...state,
        radioLabelFontWeight: payload
          ? Number(payload)
          : initialState.radioLabelFontWeight,
      };
    // ################################################################################
    // RADIO LABEL - TEXT COLOR

    case ACTIONS.RADIO_LABEL_COLOR_INPUT:
      return {
        ...state,
        radioLabelColor: payload ? payload : initialState.radioLabelColor,
      };


    // ################################################################################

    // TOGGLES

    case ACTIONS.TOGGLE_TOGGLE:
      return { ...state, addToggle: !state.addToggle };

    // #############
    case ACTIONS.TOGGLE_PADDING:
      return handleNumberInput(
        state,
        payload,
        "togglePadding",
        initialState.togglePadding
      );

    case ACTIONS.TOGGLE_PADDING_INCREMENT:
      return handleIncrement(state, "togglePadding");

    case ACTIONS.TOGGLE_PADDING_DECREMENT:
      return handleDecrement(state, "togglePadding");
    // #############
    case ACTIONS.TOGGLE_MARGIN_BOTTOM:
      return handleNumberInput(
        state,
        payload,
        "toggleMarginBottom",
        initialState.toggleMarginBottom
      );

    case ACTIONS.TOGGLE_MARGIN_BOTTOM_INCREMENT:
      return handleIncrement(state, "toggleMarginBottom");

    case ACTIONS.TOGGLE_MARGIN_BOTTOM_DECREMENT:
      return handleDecrement(state, "toggleMarginBottom");
    // #############
    case ACTIONS.TOGGLE_MARGIN_RIGHT:
      return handleNumberInput(
        state,
        payload,
        "toggleMarginRight",
        initialState.toggleMarginRight
      );

    case ACTIONS.TOGGLE_MARGIN_RIGHT_INCREMENT:
      return handleIncrement(state, "toggleMarginRight");

    case ACTIONS.TOGGLE_MARGIN_RIGHT_DECREMENT:
      return handleDecrement(state, "toggleMarginRight");
    // #############
    case ACTIONS.TOGGLE_POSITION:
      return {
        ...state,
        togglePosition: payload ? payload : initialState.togglePosition,
      };
    // #############
    case ACTIONS.TOGGLE_WIDTH:
      return handleNumberInput(
        state,
        payload,
        "toggleWidth",
        initialState.toggleWidth
      );

    case ACTIONS.TOGGLE_WIDTH_INCREMENT:
      return handleIncrement(state, "toggleWidth");

    case ACTIONS.TOGGLE_WIDTH_DECREMENT:
      return handleDecrement(state, "toggleWidth");
    // #############
    case ACTIONS.TOGGLE_HEIGHT:
      return handleNumberInput(
        state,
        payload,
        "toggleHeight",
        initialState.toggleHeight
      );

    case ACTIONS.TOGGLE_HEIGHT_INCREMENT:
      return handleIncrement(state, "toggleHeight");

    case ACTIONS.TOGGLE_HEIGHT_DECREMENT:
      return handleDecrement(state, "toggleHeight");
    // #############
    case ACTIONS.TOGGLE_BACKGROUND_COLOR:
      if (payload) {
        return { ...state, toggleBackgroundColor: payload };
      } else
        return {
          ...state,
          toggleBackgroundColor:
            initialState.toggleBackgroundColor,
        };
    // #############
    case ACTIONS.TOGGLE_BORDER_WIDTH:
      return handleNumberInput(
        state,
        payload,
        "toggleBorderWidth",
        initialState.toggleBorderWidth
      );

    case ACTIONS.TOGGLE_BORDER_WIDTH_INCREMENT:
      return handleIncrement(state, "toggleBorderWidth");

    case ACTIONS.TOGGLE_BORDER_WIDTH_DECREMENT:
      return handleDecrement(state, "toggleBorderWidth");
    // #############
    case ACTIONS.TOGGLE_BORDER_RADIUS:
      return handleNumberInput(
        state,
        payload,
        "toggleBorderRadius",
        initialState.toggleBorderRadius
      );

    case ACTIONS.TOGGLE_BORDER_RADIUS_INCREMENT:
      return handleIncrement(state, "toggleBorderRadius");

    case ACTIONS.TOGGLE_BORDER_RADIUS_DECREMENT:
      return handleDecrement(state, "toggleBorderRadius");
    // #############
    case ACTIONS.TOGGLE_BORDER_COLOR:
      if (payload) {
        return { ...state, toggleBorderColor: payload };
      } else
        return {
          ...state,
          toggleBorderColor:
            initialState.toggleBorderColor,
        };
    // #############
    case ACTIONS.TOGGLE_KNOB_WIDTH:
      return handleNumberInput(
        state,
        payload,
        "toggleKnobWidth",
        initialState.toggleKnobWidth
      );

    case ACTIONS.TOGGLE_KNOB_WIDTH_INCREMENT:
      return handleIncrement(state, "toggleKnobWidth");

    case ACTIONS.TOGGLE_KNOB_WIDTH_DECREMENT:
      return handleDecrement(state, "toggleKnobWidth");
    // #############
    case ACTIONS.TOGGLE_KNOB_HEIGHT:
      return handleNumberInput(
        state,
        payload,
        "toggleKnobHeight",
        initialState.toggleKnobHeight
      );

    case ACTIONS.TOGGLE_KNOB_HEIGHT_INCREMENT:
      return handleIncrement(state, "toggleKnobHeight");

    case ACTIONS.TOGGLE_KNOB_HEIGHT_DECREMENT:
      return handleDecrement(state, "toggleKnobHeight");
    // #############
    case ACTIONS.TOGGLE_KNOB_COLOR:
      if (payload) {
        return { ...state, toggleKnobColor: payload };
      } else
        return {
          ...state,
          toggleKnobColor:
            initialState.toggleKnobColor,
        };
    // #############
    case ACTIONS.TOGGLE_KNOB_ALIGNMENT:
      return handleNumberInput(
        state,
        payload,
        "toggleKnobAlignment",
        initialState.toggleKnobAlignment
      );

    case ACTIONS.TOGGLE_KNOB_ALIGNMENT_INCREMENT:
      return handleIncrement(state, "toggleKnobAlignment");

    case ACTIONS.TOGGLE_KNOB_ALIGNMENT_DECREMENT:
      return handleDecrement(state, "toggleKnobAlignment");
    // #############
    case ACTIONS.TOGGLE_CHECKED_BACKGROUND_COLOR:
      if (payload) {
        return { ...state, toggleCheckedBackgroundColor: payload };
      } else
        return {
          ...state,
          toggleCheckedBackgroundColor:
            initialState.toggleCheckedBackgroundColor,
        };
    // #############
    case ACTIONS.TOGGLE_KNOB_CHECKED_COLOR:
      if (payload) {
        return { ...state, toggleKnobCheckedColor: payload };
      } else
        return {
          ...state,
          toggleKnobCheckedColor:
            initialState.toggleKnobCheckedColor,
        };
    // #############
    case ACTIONS.TOGGLE_KNOB_CHECKED_ALIGNMENT_LEFT:
      return handleNumberInput(
        state,
        payload,
        "toggleKnobCheckedAlignmentLeft",
        initialState.toggleKnobCheckedAlignmentLeft
      );

    case ACTIONS.TOGGLE_KNOB_CHECKED_ALIGNMENT_LEFT_INCREMENT:
      return handleIncrement(state, "toggleKnobCheckedAlignmentLeft");

    case ACTIONS.TOGGLE_KNOB_CHECKED_ALIGNMENT_LEFT_DECREMENT:
      return handleDecrement(state, "toggleKnobCheckedAlignmentLeft");
    // #############
    case ACTIONS.TOGGLE_KNOB_CHECKED_ALIGNMENT_TOP:
      return handleNumberInput(
        state,
        payload,
        "toggleKnobCheckedAlignmentTop",
        initialState.toggleKnobCheckedAlignmentTop
      );

    case ACTIONS.TOGGLE_KNOB_CHECKED_ALIGNMENT_TOP_INCREMENT:
      return handleIncrement(state, "toggleKnobCheckedAlignmentTop");

    case ACTIONS.TOGGLE_KNOB_CHECKED_ALIGNMENT_TOP_DECREMENT:
      return handleDecrement(state, "toggleKnobCheckedAlignmentTop");


      // TOGGLE LABEL - FONT FAMILY

    case ACTIONS.TOGGLE_LABEL_FONT_FAMILY_CHANGE:
      return {
        ...state,
        toggleLabelFontFamily: action.payload,
      };

    // ################################################################################

    // TOGGLE LABEL - FONT SIZE

    case ACTIONS.TOGGLE_LABEL_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "toggleLabelFontSize",
        initialState.toggleLabelFontSize
      );

    case ACTIONS.TOGGLE_LABEL_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "toggleLabelFontSize");

    case ACTIONS.TOGGLE_LABEL_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "toggleLabelFontSize");

    // ################################################################################

    // TOGGLE LABEL - FONT WEIGHT

    case ACTIONS.TOGGLE_LABEL_FONT_WEIGHT_INPUT:
      return {
        ...state,
        toggleLabelFontWeight: payload
          ? Number(payload)
          : initialState.toggleLabelFontWeight,
      };
    // ################################################################################
    // TOGGLE LABEL - TEXT COLOR

    case ACTIONS.TOGGLE_LABEL_COLOR_INPUT:
      return {
        ...state,
        toggleLabelColor: payload ? payload : initialState.toggleLabelColor,
      };

    // ################################################################################

    // SUBMIT BUTTON
    case ACTIONS.SUBMIT_FONT_FAMILY_CHANGE:
      return {
        ...state,
        submitFontFamily: action.payload,
      };

    case ACTIONS.SUBMIT_MARGIN_TOP_INPUT:
      return handleNumberInput(
        state,
        payload,
        "submitMarginTop",
        initialState.submitMarginTop
      );
    case ACTIONS.SUBMIT_MARGIN_TOP_INCREMENT:
      return handleIncrement(state, "submitMarginTop");

    case ACTIONS.SUBMIT_MARGIN_TOP_DECREMENT:
      return handleDecrement(state, "submitMarginTop");

    case ACTIONS.SUBMIT_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "submitFontSize",
        initialState.submitFontSize
      );

    case ACTIONS.SUBMIT_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "submitFontSize");

    case ACTIONS.SUBMIT_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "submitFontSize");

    case ACTIONS.SUBMIT_WIDTH_INPUT:
      return handleNumberInput(
        state,
        payload,
        "submitWidth",
        initialState.submitWidth
      );

    case ACTIONS.SUBMIT_WIDTH_INCREMENT:
      return handleIncrement(state, "submitWidth");

    case ACTIONS.SUBMIT_WIDTH_DECREMENT:
      return handleDecrement(state, "submitWidth");

    case ACTIONS.SUBMIT_HEIGHT_INPUT:
      return handleNumberInput(
        state,
        payload,
        "submitHeight",
        initialState.submitHeight
      );
    case ACTIONS.SUBMIT_HEIGHT_INCREMENT:
      return handleIncrement(state, "submitHeight");

    case ACTIONS.SUBMIT_HEIGHT_DECREMENT:
      return handleDecrement(state, "submitHeight");

    case ACTIONS.SUBMIT_BORDER_RADIUS_INPUT:
      return handleNumberInput(
        state,
        payload,
        "submitBorderRadius",
        initialState.submitBorderRadius
      );
    case ACTIONS.SUBMIT_BORDER_RADIUS_INCREMENT:
      return handleIncrement(state, "submitBorderRadius");

    case ACTIONS.SUBMIT_BORDER_RADIUS_DECREMENT:
      return handleDecrement(state, "submitBorderRadius");

    case ACTIONS.SUBMIT_BORDER_WIDTH_INPUT:
      return handleNumberInput(
        state,
        payload,
        "submitBorderWidth",
        initialState.submitBorderWidth
      );
    case ACTIONS.SUBMIT_BORDER_WIDTH_INCREMENT:
      return handleIncrement(state, "submitBorderWidth");

    case ACTIONS.SUBMIT_BORDER_WIDTH_DECREMENT:
      return handleDecrement(state, "submitBorderWidth");
    case ACTIONS.SUBMIT_BACKGROUND_INPUT:
      return {
        ...state,
        submitBackground: payload ? payload : initialState.submitBackground,
      };

    case ACTIONS.SUBMIT_COLOR_INPUT:
      return {
        ...state,
        submitColor: payload ? payload : initialState.submitColor,
      };

    case ACTIONS.SUBMIT_BORDER_COLOR_INPUT:
      return {
        ...state,
        submitBorderColor: payload ? payload : initialState.submitBorderColor,
      };

    case ACTIONS.SUBMIT_BACKGROUND_HOVER_INPUT:
      return {
        ...state,
        submitBackgroundHover: payload
          ? payload
          : initialState.submitBackgroundHover,
      };

    case ACTIONS.SUBMIT_BORDER_COLOR_HOVER_INPUT:
      return {
        ...state,
        submitBorderColorHover: payload
          ? payload
          : initialState.submitBorderColorHover,
      };

    case ACTIONS.SUBMIT_COLOR_HOVER_INPUT:
      return {
        ...state,
        submitColorHover: payload ? payload : initialState.submitColorHover,
      };

    case ACTIONS.TRANSITION_MAIN_INPUT:
      return {
        ...state,
        transitionMain: payload ? payload : initialState.transitionMain,
      };

    case ACTIONS.SUBMIT_TEXT_ALIGN_INPUT:
      return {
        ...state,
        submitTextAlign: payload ? payload : initialState.submitTextAlign,
      };

    case ACTIONS.SUBMIT_TEXT_INPUT:
      return {
        ...state,
        submitButtonText: payload ? payload : initialState.submitButtonText,
      };

    case ACTIONS.SUBMIT_FONT_WEIGHT_INPUT:
      return {
        ...state,
        submitFontWeight: payload
          ? Number(payload)
          : initialState.submitFontWeight,
      };
    case ACTIONS.SUBMIT_BACKGROUND_IMAGE_INPUT:
      return {
        ...state,
        submitBackgroundImage: payload
          ? payload
          : initialState.submitBackgroundImage,
      };

    case ACTIONS.SUBMIT_BACKGROUND_IMAGE_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "submitBackgroundImageSize",
        initialState.submitBackgroundImageSize
      );
    case ACTIONS.SUBMIT_BACKGROUND_IMAGE_SIZE_INCREMENT:
      return handleIncrement(state, "submitBackgroundImageSize");

    case ACTIONS.SUBMIT_BACKGROUND_IMAGE_SIZE_DECREMENT:
      return handleDecrement(state, "submitBackgroundImageSize");

    case ACTIONS.SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_INPUT:
      return handleNumberInput(
        state,
        payload,
        "submitBackgroundImagePositionRight",
        initialState.submitBackgroundImagePositionRight
      );
    case ACTIONS.SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_INCREMENT:
      return handleIncrement(state, "submitBackgroundImagePositionRight");

    case ACTIONS.SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_DECREMENT:
      return handleDecrement(state, "submitBackgroundImagePositionRight");

    case ACTIONS.SUBMIT_BUTTON_ALIGN_INPUT:
      return {
        ...state,
        submitButtonAlign: payload ? payload : initialState.submitButtonAlign,
      };

    case ACTIONS.SUBMIT_WIDTH_UNITS:
      return {
        ...state,
        submitWidthUnits: payload ? payload : initialState.submitWidthUnits,
      };

    case ACTIONS.SUBMIT_TOGGLE_BACKGROUND_IMAGE:
      return {
        ...state,
        addBackgroundImage: !state.addBackgroundImage,
        submitBackgroundImage: !state.addBackgroundImage
          ? "https://storage.pardot.com/972093/16740775659TkeR9AK/white_arrow.png"
          : '',
      };

    // ################################################################################
    // ERROR TEXT

    case ACTIONS.TOGGLE_ERRORS:
      return { ...state, addErrors: !state.addErrors };

    // #############

    case ACTIONS.ERRORTEXT_COLOR:
      return {
        ...state,
        errorTextColor: payload ? payload : initialState.errorTextColor,
      };
    // #############

    case ACTIONS.ERRORTEXT_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "errorTextFontSize",
        initialState.errorTextFontSize
      );

    case ACTIONS.ERRORTEXT_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "errorTextFontSize");

    case ACTIONS.ERRORTEXT_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "errorTextFontSize");
    // #############

    case ACTIONS.ERRORTEXT_FONT_FAMILY_CHANGE:
      return {
        ...state,
        errorTextFontFamily: action.payload,
      };
    // #############

    case ACTIONS.ERRORTEXT_TOP_SPACING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "errorTextTopSpacing",
        initialState.errorTextTopSpacing
      );
    case ACTIONS.ERRORTEXT_TOP_SPACING_INCREMENT:
      return handleIncrement(state, "errorTextTopSpacing");

    case ACTIONS.ERRORTEXT_TOP_SPACING_DECREMENT:
      return handleDecrement(state, "errorTextTopSpacing");

    // #############

    case ACTIONS.ERRORTEXT_FONT_WEIGHT_INPUT:
      return {
        ...state,
        errorTextFontWeight: payload
          ? Number(payload)
          : initialState.errorTextFontWeight,
      };

    // ################################################################################

    case ACTIONS.ERRORTEXT_INLINE_PADDING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "errorTextPaddingInline",
        initialState.errorTextPaddingInline
      );

    case ACTIONS.ERRORTEXT_INLINE_PADDING_INCREMENT:
      return handleIncrement(state, "errorTextPaddingInline");

    case ACTIONS.ERRORTEXT_INLINE_PADDING_DECREMENT:
      return handleDecrement(state, "errorTextPaddingInline");


    // ################################################################################
    // ERROR HEADLINE


    case ACTIONS.ERRORHEAD_FONT_SIZE_INPUT:
      return handleNumberInput(
        state,
        payload,
        "errorHeadFontSize",
        initialState.errorHeadFontSize
      );

    case ACTIONS.ERRORHEAD_FONT_SIZE_INCREMENT:
      return handleIncrement(state, "errorHeadFontSize");

    case ACTIONS.ERRORHEAD_FONT_SIZE_DECREMENT:
      return handleDecrement(state, "errorHeadFontSize");
    // #############

    case ACTIONS.ERRORHEAD_COLOR:
      return {
        ...state,
        errorHeadColor: payload ? payload : initialState.errorHeadColor,
      };
    // #############

    case ACTIONS.ERRORHEAD_FONT_FAMILY_CHANGE:
      return {
        ...state,
        errorHeadFontFamily: action.payload,
      };
    // #############

    case ACTIONS.ERRORHEAD_BOTTOM_SPACING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "errorHeadBottomSpacing",
        initialState.errorHeadBottomSpacing
      );
    case ACTIONS.ERRORHEAD_BOTTOM_SPACING_INCREMENT:
      return handleIncrement(state, "errorHeadBottomSpacing");

    case ACTIONS.ERRORHEAD_BOTTOM_SPACING_DECREMENT:
      return handleDecrement(state, "errorHeadBottomSpacing");

    // #############

    case ACTIONS.ERRORHEAD_FONT_WEIGHT_INPUT:
      return {
        ...state,
        errorHeadFontWeight: payload
          ? Number(payload)
          : initialState.errorHeadFontWeight,
      };

    // ################################################################################

    case ACTIONS.ERRORHEAD_INLINE_PADDING_INPUT:
      return handleNumberInput(
        state,
        payload,
        "errorHeadPaddingInline",
        initialState.errorHeadPaddingInline
      );

    case ACTIONS.ERRORHEAD_INLINE_PADDING_INCREMENT:
      return handleIncrement(state, "errorHeadPaddingInline");

    case ACTIONS.ERRORHEAD_INLINE_PADDING_DECREMENT:
      return handleDecrement(state, "errorHeadPaddingInline");

    // ################################################################################

    case ACTIONS.ERRORHEAD_BACKGROUND_COLOR:
      return {
        ...state,
        errorHeadBackground: payload ? payload : initialState.errorHeadBackground,
      };


    default:
      return state;
  }
};
